import Crud from '../views/ProductCategory/Crud'
import Entity from '../views/ProductCategory/Add'

let routes = {
    path: '/product_categories',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/product_categories/add',
            name: 'NewProductCategory',
            component: Entity,
            meta: {
                pageTitle: 'Categoria de Produto',
                breadcrumb: [
                    { text: 'Categoria de Produto', active: false, to: '/product_categories' },
                    { text: 'Adicionar Categoria de Produto', active: true }
                ],
            },
        },
        {
            path: '/product_categories/edit/:id?',
            name: 'EditProductCategory',
            component: Entity,
            meta: {
                pageTitle: 'Categoria de Produto',
                breadcrumb: [
                    { text: 'Categoria de Produto', active: false, to: '/product_categories' },
                    { text: 'Editar Categoria de Produto', active: true }
                ],
            },
        },
        {
            path: '/product_categories',
            name: 'list-product-categories',
            component: Crud,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    { text: 'Categoria de Produto', active: true },
                ],
            },
        },
    ]
};

export default routes
